import React from 'react'
import { ButtonGroup } from 'react-bootstrap'
import { BusyButton } from '@ztechapps/webui.button'
import { GridListViewModeEnum } from './GridListViewModeEnum'

export type GridListToggleProps = {
  viewMode: GridListViewModeEnum
  setViewMode: (mode: GridListViewModeEnum) => void
}

export const GridListToggle = ({ viewMode, setViewMode }: GridListToggleProps) => (
  <ButtonGroup>
    <BusyButton
      icon="th-large"
      title="Grid view"
      aria-label="Grid view"
      variant={viewMode === GridListViewModeEnum.Grid ? 'primary' : 'outline-secondary'}
      active={viewMode === GridListViewModeEnum.Grid}
      onClick={() => setViewMode(GridListViewModeEnum.Grid)}
    />
    <BusyButton
      icon="list"
      title="List view"
      aria-label="List view"
      variant={viewMode === GridListViewModeEnum.List ? 'primary' : 'outline-secondary'}
      active={viewMode === GridListViewModeEnum.List}
      onClick={() => setViewMode(GridListViewModeEnum.List)}
    />
  </ButtonGroup>
)
